import React, { useState } from 'react'
import { Popup, Form, Input } from 'semantic-ui-react'
import { checkHttpPrefix, MAIL_TO_REGEX, normalizeUrl } from 'organisms/SurveyConfiguration/utils'
import { toast } from 'libs/toast'

function AddLinkPopup({ onAddLink, trigger, onRemoveLink, initialLink = '' }) {
  const [link, setLink] = useState('')
  const [open, setOpen] = useState(false)

  const normalizedLink = normalizeUrl(link)
  const isValidHTTPLink = checkHttpPrefix.test(normalizedLink)
  const isValidMailToLink = MAIL_TO_REGEX.test(normalizedLink)
  const isValid = isValidHTTPLink || isValidMailToLink

  function _onSubmit(e) {
    e.preventDefault()
    e.stopPropagation()

    if (isValid) {
      setOpen(false)
      onAddLink(normalizedLink)
      setLink('')
    } else {
      toast.error('Oops! Please enter a valid URL (e.g. example.com) or a mailto: link.')
    }
  }

  function _onRemoveLink() {
    setOpen(false)
    onRemoveLink(link)
    setLink('')
  }

  const content = () => (
    <Form onSubmit={_onSubmit}>
      <Form.Group inline className="mb0">
        <Form.Field width={16} error={link !== '' && !isValid} control={Input}>
          <Input
            type="text"
            name="linkText"
            required
            value={link}
            onChange={(_, { value }) => setLink(value)}
          />
        </Form.Field>

        <button className="ml2 ui button primary" type="submit">
          Link
        </button>
        <button className="ml1 ui button basic" type="button" onClick={_onRemoveLink}>
          Unlink
        </button>
      </Form.Group>
    </Form>
  )
  return (
    <Popup
      basic
      wide="very"
      content={content}
      on="click"
      onClose={() => setOpen(false)}
      onOpen={() => {
        setOpen(true)
        setLink(initialLink)
      }}
      open={open}
      trigger={trigger}
      style={{ minWidth: '550px' }}
    />
  )
}

export default AddLinkPopup



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RichEditor/AddLinkPopup.js